import { useLandingPage } from '#src/app/pages/searchV2/shared/hooks';

import { LandingPageLayout } from './components/LandingPageLayout';
import { ResultsPageLayout } from './components/ResultsPageLayout';
import { usePageBody } from './hooks/usePageBody';

export const PageBody = () => {
	usePageBody();

	const {
		data: { showLandingPage },
	} = useLandingPage();

	return <div className="pb-32">{showLandingPage ? <LandingPageLayout /> : <ResultsPageLayout />}</div>;
};
